/**
 * Application configuration
 */

const config = {
  // Application version - should be updated with each release
  appVersion: process.env.REACT_APP_VERSION,
  
  // Other configuration settings can be added here
  apiEndpoints: {
    // API endpoints if needed
  },
};

export default config;
